import{j as s}from"./chunk-GEPA7FLG.js";s();var r=class{constructor(t){this.nftNonces=[];Object.assign(this,t)}};export{r as a};
//# sourceMappingURL=chunk-WGWUFZSA.js.map
